export enum RiskProfileStatus {
  REFERRAL = 'REFERRAL',
  QUOTE = 'QUOTE',
}
